import BsPagination from './index.vue'
export default BsPagination